import styled from 'styled-components';
import { breakpoints, colors, fonts, pxToCssFont, pxToRem } from '@vfit/shared/themes';

export const MainContainer = styled.div`
  margin: 24px 44px 40px 44px;
  background-color: ${colors.$ffffff};

  @media (min-width: ${breakpoints.tablet}) {
    margin: 0 auto;
    background-color: ${colors.$ffffff};
  }

  @media (min-width: ${breakpoints.desktop}) {
    margin: 0 auto;
    background-color: ${colors.$ffffff};
  }
`;

export const CardContainer = styled.div<{ haveMargin?: boolean }>`
  margin-top: ${({ haveMargin }) => (haveMargin ? '24px' : 0)};
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  @media (min-width: ${breakpoints.tablet}) {
    flex-direction: column;
    padding-bottom: 64px;
    padding-right: 60px;
    padding-left: 60px;
    gap: 24px;
    align-items: center;
  }

  @media (min-width: ${breakpoints.desktop}) {
    align-items: flex-start;
    flex-direction: row;
    padding-bottom: 64px;
    padding-right: 109px;
    padding-left: 109px;
    gap: 32px;
  }
`;

export const DescriptionBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media (min-width: ${breakpoints.desktop}) {
    min-width: 296px;
  }
`;

export const Title = styled.div`
  p {
    margin: 0;
    font-family: ${fonts.exbold};
    font-weight: 400;
    ${pxToCssFont(24, 32)};
    overflow: auto;
    padding-bottom: ${pxToRem(8)};
  }
  @media (min-width: ${breakpoints.desktop}) {
    p {
      ${pxToCssFont(28, 36)}
    }
  }
`;

export const TitleForCards = styled.h4`
  font-family: ${fonts.exbold};
  font-weight: 400;
  ${pxToCssFont(24, 38)};
  overflow: auto;
  padding-bottom: ${pxToRem(16)};
  margin: 0;
  margin-top: 24px;
  text-align: center;
  p {
    margin: 0;
  }

  @media (min-width: ${breakpoints.desktop}) {
    ${pxToCssFont(28, 36)}
    p {
      margin-bottom: 0;
    }
  }
`;

export const Description = styled.div`
  p {
    margin: 0;
    font-family: ${fonts.regular};
    font-weight: 400;
    ${pxToCssFont(18, 24)}
    color: ${colors.$262626};
  }

  @media (min-width: ${breakpoints.desktop}) {
    p {
      ${pxToCssFont(16, 22)}
    }
  }
`;

export const BottomDescription = styled.p`
  margin: 0;
  p {
    margin: 0;
    font-family: ${fonts.regular};
    font-weight: 700;
    ${pxToCssFont(18, 24)}
    color: ${colors.$262626};
  }

  @media (min-width: ${breakpoints.desktop}) {
    p {
      ${pxToCssFont(18, 24)}
    }
  }
`;

export const CtaContainer = styled.div`
  margin-top: 8px;

  @media (min-width: ${breakpoints.tablet}) {
    display: block;
  }

  @media (min-width: ${breakpoints.desktop}) {
    display: inline-block;
  }
`;

export const ContainerCard = styled.div<{ haveMargin?: boolean }>`
  display: flex;
  justify-content: center;
  margin-top: 32px;

  @media (min-width: ${breakpoints.tablet}) {
    margin-top: 0;
    justify-content: center;
    max-width: 296px;
  }

  @media (min-width: ${breakpoints.desktop}) {
    margin-top: ${({ haveMargin }) => (haveMargin ? '60px' : 0)};
    align-items: center;
  }
`;

export const ContainerAction = styled.div<{
  havePrice?: boolean;
  buttonColor?: string;
  textColor?: string;
}>`
  margin-top: 16px;
  button {
    background-color: ${({ buttonColor }) => (buttonColor ? buttonColor : 'auto')};
    border-color: ${({ buttonColor }) => (buttonColor ? buttonColor : 'auto')};
    color: ${({ textColor }) => (textColor ? textColor : 'auto')};
    :hover {
      background-color: ${({ buttonColor }) => (buttonColor ? buttonColor : 'auto')};
      border-color: ${({ buttonColor }) => (buttonColor ? buttonColor : 'auto')};
      color: inherit;
    }
  }
  @media (min-width: ${breakpoints.desktop}) {
    margin-top: ${({ havePrice }) => (havePrice ? '16px' : '68px')};
  }
`;

export const ImageContainer = styled.div`
  max-height: 40px;
  max-width: 200px;
  margin: 0 auto;
  margin-bottom: 16px !important;
  width: 100%;

  @media (min-width: ${breakpoints.desktop}) {
    margin: inherit !important;
    margin-bottom: 24px !important;
    width: inherit !important;
  }
`;

export const ImageContainerForCards = styled.div`
  height: 40px;
  max-width: 200px;
  margin: 0 auto;
  margin-bottom: 16px !important;
  width: 100%;
  img {
    object-fit: contain !important;
  }

  @media (min-width: ${breakpoints.tablet}) {
    margin: inherit !important;
    margin-bottom: 24px !important;
    margin-top: 24px !important;
    width: inherit !important;
  }

  @media (min-width: ${breakpoints.desktop}) {
    margin: inherit !important;
    margin-bottom: 24px !important;
    margin-top: 24px !important;
    width: inherit !important;
  }
`;

export const EditAddress = styled.span`
  font-family: ${fonts.regular};
  font-weight: 700;
  ${pxToCssFont(18, 26)}
  text-decoration-line: underline;
  cursor: pointer;
  margin: 0;
`;

export const TopLabelContainer = styled.div`
  p {
    margin: 0;
    margin-bottom: 16px;
    font-family: ${fonts.regular};
    ${pxToCssFont(16, 22)};
  }
`;
